var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.forecastDataTemplateComponent,{tag:"component",attrs:{"fids":_vm.fids,"layer-name":_vm.layerName,"forecast-label":_vm.forecastLabel,"dataset":_vm.dataset,"data-by-id":_vm.dataById,"is-province":_vm.isProvince}})
}
var staticRenderFns = []

export { render, staticRenderFns }